import React, { useEffect, useState } from 'react';
import NextPrevButtons from '../Shared/NextPrevButtons';
import { CreateContractHtml } from '../../Helpers/contractHelper';
import { makeStyles } from '@material-ui/core';
import { dataService } from '../../Services/data.service';
import { toast } from 'react-toastify';
import FinishContractDialog from '../Dialogs/FinishContractDialog';

export default function AddFormResultComponent(props) {

    const [html, setHtml] = useState(null)
    const [refNumber, setRefNumber] = useState(null)
    const [finishContractDialogOpen, setFinishContractDialogOpen] = useState(false)
    const classes = useStyles();

    useEffect(() => {

        Promise.all([
            dataService.getLanguages(),
            dataService.getSuppliers(),
            dataService.getDocumentTextOverview(),
            dataService.getTranslations(),
            dataService.getTranslationValues(),
            dataService.getPurchaseOrderTypes(),
            dataService.getUoms(),
            dataService.getCountries(),
            dataService.getBrokers(),
            dataService.getPaymentTerms(),
            dataService.getTransportTypes(),
            dataService.getProducts()
        ]).then((results) => {

            let contractData = {
                languages: results[0].Results,
                suppliers: results[1].Results,
                documentTextOverview: results[2].Results,
                translations: results[3].Results,
                translationValues: results[4].Results,
                purchaseOrderTypes: results[5].Results,
                unitOfMeasurements: results[6].Results,
                countries: results[7].Results,
                brokers: results[8].Results,
                paymentTerms: results[9].Results,
                transportTypes: results[10].Results,
                products: results[11].Results
            }

            let contractHtml = CreateContractHtml(props.addPage, contractData);

            if (JSON.stringify(html) !== JSON.stringify(contractHtml)) {
                setHtml(contractHtml)
            }

            if (JSON.stringify(props.addPage.externalReferenceID) !== JSON.stringify(refNumber)) {
                setRefNumber(props.addPage.externalReferenceID)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) });

    }, [])

    const printContract = async () => {
        try {
            var pri = document.getElementById("agrocontract").contentWindow;
            pri.document.open();
            pri.document.write(html);
            pri.document.close();
            pri.focus();
            pri.print();
        }
        catch (err) {
            console.log(err.message);
        }
    }

    const closeDialog = () => {
        props.actions.SetDialogState(false);
    }

    const FinishContract = () => {

        if (props.addPage.editcontractmode) {
            props.actions.SetEditContractMode(false);
        }

        let freeClauses = []
        let purchaseOrderLines = []
        props.addPage.selectedFreeClauses.map(x => freeClauses.push({ Sequence: x.Index, DocumentTextId: x.ID }))
        var i;
        for (i = 0; i < props.addPage.purchaseOrderLines.length; i++) {

            let line = props.addPage.purchaseOrderLines[i]
            let purchaseOrderLine = {
                FromDate: line.fromDate,
                ToDate: line.toDate,
                ProductID: line.productID,
                Quantity: parseFloat(line.quantity),
                UnitOfMeasurementID: line.unitOfMeasurementID,
                UnitPrice100Kg: line.unitPrice100Kg,
                TonPerHectContractPrice:line.contractPrice
            }
            purchaseOrderLines.push(purchaseOrderLine)
        }
        dataService.savePurchaseOrder(props.addPage, freeClauses, purchaseOrderLines,props.authentication.userId).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        dataService.saveCertificate(props.addPage.certificateInfo.number,props.addPage.certificateInfo.validUntil,props.addPage.vendorID).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        props.actions.ResetAddForm();
        // props.actions.ResetaddPageTitle();
        props.actions.SetDialogState(false);
    }

    const FinishContractAndPrint = async () => {
        FinishContract();
        await printContract();
        //await addPageSavePurchaseOrdersToFile();
    }
    // TODO
    // SavePurchaseOrdersToFile = async() => {
    //     let now = Date.now();
    //     let nowAsString = now.getFullYear() + now.getMonth() + now.getDay() + "_" + now.getHours() + now.getMinutes() + now.getSeconds();

    //     let fileUri = FileSystem.documentDirectory + "purchaseOrders" + nowAsString + ".json";
    //     await FileSystem.writeAsStringAsync(fileUri, props.localstore.purchaseOrders.tojsonofzo, { encoding: FileSystem.EncodingType.UTF8 });
    // }


    return (
        <div>
            <div className={classes.formContainer}>
                <div className={classes.container}>
                    <iframe id="agrocontract" className={classes.frame} srcdoc={html} height="800px" width="100%"></iframe>
                    {/* <WebView 
                        className={classes.pdf}
                        javaScriptEnabled={true}
                        domStorageEnabled={true}
                        allowFileAccess={true}
                        key={props.addPage.externalReferenceID}
                        source={{ html: addPagestate.html }}
                    /> */}
                </div>
                <FinishContractDialog finishContract={FinishContractAndPrint} dialogOpen={props.addPage.dialogVisible} closeDialog={closeDialog}></FinishContractDialog>
                <NextPrevButtons hasPrevious={props.hasPrevious} hasNext={props.hasNext} SetPrevious={props.SetPrevious} SetNext={props.SetNext}></NextPrevButtons>

            </div>


            {/* <MaterialDialog
                title={"Finish contract?"}
                visible={props.addPage.dialogVisible}
                onOk={() => FinishContractAndPrint()}
                onCancel={() => closeDialog()}
                okLabel={"Finish"}
                cancelLabel={"Cancel"}>
                <Text>Finish contract</Text>
            </MaterialDialog> */}
        </div>
    )

}

const useStyles = makeStyles({
    formContainer: {
        width: "1000px",
        marginLeft: "auto",
        marginRight: "auto",
        boxSizing: "border-box",
        paddingTop: "20px"
    },
})